import { QUERY_KEYS, soCaiColumns, thanhToanPhaiThuColumns, thanhToanPhaiTraColumns, theKhoColumns } from '@/constants';
import { InfoDropdownV2, type InfoTableItem } from '@/components/custom/erp';

interface InfoProps {
  uuid: string;
  ma_ct?: string;
}

const InfoDropdown = ({ uuid, ma_ct }: InfoProps) => {
  const tableItems: InfoTableItem[] = [
    { title: 'Xem sổ cái', columns: soCaiColumns, endpoint: QUERY_KEYS.SO_CAI, group: 1 },
    {
      title: 'Thanh toán phải thu',
      columns: thanhToanPhaiThuColumns,
      endpoint: QUERY_KEYS.THANH_TOAN_PHAI_THU,
      group: 1
    },
    {
      title: 'Thanh toán phải trả',
      columns: thanhToanPhaiTraColumns,
      endpoint: QUERY_KEYS.THANH_TOAN_PHAI_TRA,
      group: 1
    },
    { title: 'Thông tin chứng từ', columns: theKhoColumns, endpoint: QUERY_KEYS.THONG_TIN_CHUNG_TU, group: 2 }
  ];

  return <InfoDropdownV2 uuid={uuid} ma_ct={ma_ct} tableItems={tableItems} />;
};

export default InfoDropdown;
